import FeatureSummary from './FeatureSummary';
export default FeatureSummary;